export const getVersion = () => {
  return process.env.REACT_APP_DEPIX_VERSION || 'dev';
};
